/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum DeviceCategory {
  Wearable = 'Wearable',
  BloodPressure = 'BloodPressure',
  Glucose = 'Glucose'
}
